import { SupportedCurrency } from 'constants/currency';

const SYMBOL_TO_CURRENCY: Partial<Record<string, SupportedCurrency>> = {
  'HK$': 'HKD',
  'CN¥': 'CNY',
  'S$': 'SGD',
  'A$': 'AUD',
  'C$': 'CAD',
  '€': 'EUR',
  '£': 'GBP',
  '¥': 'JPY',
};

export const parsePriceAmount = (value?: string): number | undefined => {
  if (!value) return undefined;
  const match = value.match(/-?[\d,.]+/);
  if (!match) return undefined;
  const numericString = match[0].replace(/,/g, '');
  const parsed = Number(numericString);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const parseCurrencyCode = (value?: string): string | undefined => {
  if (!value) return undefined;
  const trimmed = value.trim();

  for (const [symbol, code] of Object.entries(SYMBOL_TO_CURRENCY)) {
    if (trimmed.includes(symbol)) return code;
  }

  const match = trimmed.match(/\b([A-Z]{3})\b$/);
  return match?.[1];
};

export const formatAmountWithCurrency = (amount: number, currency: string): string =>
  `${amount} ${currency.toUpperCase()}`;

